<div class="flex items-center justify-center dialog-header">
    {{type}} User

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content">
    <form [formGroup]="userForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">

        <!-- First Name -->
        <div class="flex flex-col">
            <label for="fname" class="mb-2 font-semibold">First Name *</label>
            <input pInputText id="fname" formControlName="fname"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            <div *ngIf="userForm.get('fname')?.invalid && (userForm.get('fname')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                First name is required.
            </div>
        </div>

        <!-- Last Name -->
        <div class="flex flex-col">
            <label for="lname" class="mb-2 font-semibold">Last Name *</label>
            <input pInputText id="lname" formControlName="lname"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            <div *ngIf="userForm.get('lname')?.invalid && (userForm.get('lname')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Last name is required.
            </div>
        </div>

        <!-- Username -->
        <div class="flex flex-col">
            <label for="username" class="mb-2 font-semibold">Username *</label>
            <input pInputText id="username" formControlName="username"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            <div *ngIf="userForm.get('username')?.invalid && (userForm.get('username')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Username is required.
            </div>
        </div>

        <!-- Password -->
        <div class="flex flex-col" *ngIf="type !== 'Update'">
            <label for="password" class="mb-2 font-semibold">Password *</label>
            <input pInputText type="password" id="password" formControlName="password"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            <div *ngIf="userForm.get('password')?.invalid && (userForm.get('password')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Password is required.
            </div>
        </div>

        <!-- Email -->
        <div class="flex flex-col">
            <label for="email" class="mb-2 font-semibold">Email *</label>
            <input pInputText id="email" formControlName="email"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            <div *ngIf="userForm.get('email')?.errors?.['email'] && (userForm.get('email')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Invalid email format.
            </div>
        </div>

        <!-- Gender -->
        <div class="flex flex-col">
            <label for="gender" class="mb-2 font-semibold">Gender *</label>
            <p-select id="gender" [options]="genderOptions" formControlName="gender"
                placeholder="Select gender" class="w-full" />
            
            <div *ngIf="userForm.get('gender')?.invalid && (userForm.get('gender')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Gender is required.
            </div>
        
        </div>

        <!-- Prefix -->
        <div class="flex flex-col">
            <label for="prefix" class="mb-2 font-semibold">Prefix</label>
            <input pInputText id="prefix" formControlName="prefix"
                class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
        </div>

        <!-- Department -->
        <div class="flex flex-col">
            <label for="dept_id" class="mb-2 font-semibold">Department *</label>
            <p-select id="dept_id" [options]="departmentOptions" formControlName="dept_id"
                placeholder="Select department" class="w-full" />
            <div *ngIf="userForm.get('dept_id')?.invalid && (userForm.get('dept_id')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Department is required.
            </div>
        </div>

        <!-- Role -->
        <div class="flex flex-col">
            <label for="role_id" class="mb-2 font-semibold">Role *</label>
            <p-select id="role_id" [options]="roleOptions" formControlName="role_id"
                placeholder="Select role" class="w-full" />
            <div *ngIf="userForm.get('role_id')?.invalid && (userForm.get('role_id')?.touched || submitted)"
                class="text-red-500 text-xs mt-1">
                Role is required.
            </div>
        </div>

        <!-- Status -->
        <div class="flex flex-col">
            <label for="status" class="mb-2 font-semibold">Status *</label>
            <p-select id="status" [options]="statusOptions" formControlName="status"
                placeholder="Select status" class="w-full" />
        </div>

        <!-- Campus -->
        <div class="flex flex-col">
            <label for="center_id" class="mb-2 font-semibold">Center *</label>
            <p-select id="center_id" [options]="centerOptions"  formControlName="center_id"
                placeholder="Select Center" class="w-full" />
        </div>

        <!-- 2FA -->
        <div class="flex flex-col">
            <label for="twoFactorAuthentication" class="mb-2 font-semibold">Two-Factor Authentication *</label>
            <p-select id="twoFactorAuthentication" [options]="twoFAOptions" formControlName="twoFactorAuthentication"
                placeholder="Enable Two FactorAuthentication" class="w-full" />
        </div>

        <!-- Details -->
        <div class="flex flex-col col-span-2">
            <label for="details" class="mb-2 font-semibold">Details</label>
            <textarea pInputTextarea id="details" formControlName="details"
                class="w-full border rounded"></textarea>
        </div>

        <!-- Submit -->
        <div class="col-span-2 flex justify-end mt-6">
            <p-button label="Submit" type="submit"
                [loading]="isLoading" icon="pi pi-check"
                class="w-full" [disabled]="userForm.invalid || isLoading"></p-button>
        </div>
    </form>
</div>
